<template>
  <b-container fluid>
    <b-row class="vh-100">
      <b-col class="flex-center position-ref full-height h-100">
        <div class="content-splash">
          <h4 class="align-middle">
            <b-img src="~@/assets/img/logo.png" alt="logo" height="40px" />
            Page not found
          </h4>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/layouts/splash';
</style>
